import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Function to initialize the React app
const initChatWidget = () => {
  // Check if we're in WordPress environment
  const isWordPress = typeof window.chatWidgetConfig !== "undefined";
  const rootElement =
    document.getElementById("shop-assistant-chat-widget-root") ||
    document.getElementById("root");

  if (!rootElement) return;

  const root = ReactDOM.createRoot(rootElement);

  // In WordPress, use the config from WordPress
  if (isWordPress) {
    root.render(
      <React.StrictMode>
        <App
          tenantId={window.chatWidgetConfig.tenant_id}
          tenantSecret={window.chatWidgetConfig.tenant_secret}
        />
      </React.StrictMode>
    );
  } else {
    // In standalone mode (development), use environment variables
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }
};

// Initialize the chat widget when the DOM is fully loaded
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initChatWidget);
} else {
  initChatWidget();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
